import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { KwikspaceService } from 'src/app/services/kwikspace.service';
import { CreateCustomerAddressFailure, CreateCustomerAddressSuccess, CreateCustomerCompanyFailure, CreateCustomerCompanySuccess, CreateCustomerFailure, CreateCustomerSuccess, CustomerActionTypes, GetCustomerFailure, GetCustomerListFailure, GetCustomerListSuccess, GetCustomerSuccess, UpdateCustomerAddressFailure, UpdateCustomerAddressSuccess, UpdateCustomerCompanyFailure, UpdateCustomerCompanySuccess, UpdateCustomerFailure, UpdateCustomerSuccess } from "../actions/customer.action";

@Injectable()
export class CustomerEffects {
  public constructor(
    private actions$: Actions,
    private service: KwikspaceService
  ) { }

  @Effect()
  GetCustomerList$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.GET_CUSTOMER_LIST),
    switchMap((action: any) => {
      return this.service.getCustomerList(action.payload).pipe(
        map((res: any) => new GetCustomerListSuccess(res)),
        catchError((error) => of(new GetCustomerListFailure(error)))
      );
    })
  );

  @Effect()
  GetCustomer$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.GET_CUSTOMER),
    switchMap((action: any) => {
      return this.service.getCustomerById(action.id).pipe(
        map((res: any) => new GetCustomerSuccess(res)),
        catchError((error) => of(new GetCustomerFailure(error)))
      );
    })
  );

  @Effect()
  CreateCustomer$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.CREATE_CUSTOMER),
    switchMap((action: any) => {
      return this.service.createCustomer(action.payload).pipe(
        map((res: any) => new CreateCustomerSuccess(res)),
        catchError((error) => of(new CreateCustomerFailure(error)))
      );
    })
  );

  @Effect()
  UpdateCustomer$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.UPDATE_CUSTOMER),
    switchMap((action: any) => {
      return this.service.updateCustomer(action.payload, action.id).pipe(
        map((res: any) => new UpdateCustomerSuccess(res)),
        catchError((error) => of(new UpdateCustomerFailure(error)))
      );
    })
  );

  @Effect()
  CreateCustomerCompany$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.CREATE_CUSTOMER_COMPANY),
    switchMap((action: any) => {
      return this.service.createCustomerCompany(action.payload).pipe(
        map((res: any) => new CreateCustomerCompanySuccess(res)),
        catchError((error) => of(new CreateCustomerCompanyFailure(error)))
      );
    })
  );

  @Effect()
  UpdateCustomerCompany$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.UPDATE_CUSTOMER_COMPANY),
    switchMap((action: any) => {
      return this.service.updateCustomerCompany(action.payload, action.id).pipe(
        map((res: any) => new UpdateCustomerCompanySuccess(res)),
        catchError((error) => of(new UpdateCustomerCompanyFailure(error)))
      );
    })
  );

  @Effect()
  CreateCustomerAddress$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.CREATE_CUSTOMER_ADDRESS),
    switchMap((action: any) => {
      return this.service.createCustomerAddress(action.payload).pipe(
        map((res: any) => new CreateCustomerAddressSuccess(res)),
        catchError((error) => of(new CreateCustomerAddressFailure(error)))
      );
    })
  );

  @Effect()
  UpdateCustomerAddress$: Observable<any> = this.actions$.pipe(
    ofType(CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS),
    switchMap((action: any) => {
      return this.service.updateCustomerAddress(action.payload, action.id).pipe(
        map((res: any) => new UpdateCustomerAddressSuccess(res)),
        catchError((error) => of(new UpdateCustomerAddressFailure(error)))
      );
    })
  );
}
